@if (!isLoading) {
<div [loadingOverlay]="isLoading">
  @if (workflows.length) {
  @for (workflow of workflows; track workflow) {
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header" [class.border-bottom-0]="!workflow.Tasks?.length">
          {{ workflow.WorkflowId }} - {{ workflow.WorkflowDefinitionName }} <span class="badge bg-secondary">{{
            workflow.WorkflowStateName }}</span>
          @if (canCloseWorkflows) {
          <button type="button" class="btn btn-primary btn-sm float-end" [disabled]="!workflow.CanClose"
            (click)="openCloseWorkflowModal(closeWorkflowModal, workflow)">
            {{ workflow.CanClose ? 'Close' : 'Cannot Close' }}
          </button>
          }
        </div>
        @if (workflow.Tasks?.length) {
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <ul class="list-group">
                <li class="list-group-item">
                  <strong>Language</strong>
                  <span class="float-end">{{ workflow.LanguageName }}</span>
                </li>
                <li class="list-group-item">
                  <strong>Keyword</strong>
                  <span class="float-end">{{ workflow.Keyword || 'N/A' }}</span>
                </li>
                <li class="list-group-item">
                  <strong>Area</strong>
                  <span class="float-end">{{ workflow.Area || 'N/A' }}</span>
                </li>
                <li class="list-group-item">
                  <strong>Url</strong>
                  <span class="float-end">{{ workflow.Url }}</span>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="list-group">
                @for (task of workflow.Tasks; track task) {
                <li class="list-group-item" [ngClass]="{'ordering-task-background': task.IsOrderingTask}">
                  <strong>Task</strong> {{ task.TaskId }} - {{ task.TaskTypeName }} <small>{{ task.InsertedDate |
                    dateText:'MM/DD/YYYY' }}</small><span class="badge bg-secondary">{{ task.TaskStatusName }}</span>
                </li>
                }
              </ul>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }
  } @else {
  <div class="alert alert-info">
    No open workflows found for this customer.
  </div>
  }
</div>
}

<ng-template #closeWorkflowModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Close Workflow - {{ workflowToClose.WorkflowId }} - {{
        workflowToClose.WorkflowDefinitionName }}</h4>
    </div>
    <div class="modal-body">
      <label class="form-label">Note (required)</label>
      <textarea type="text" [(ngModel)]="closeNote" ngbAutofocus class="form-control"></textarea>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="closeModal(modal)">Cancel</button>
      <button type="button" (click)="closeWorkflow(modal)" class="btn btn-primary" [disabled]="!closeNote">Save</button>
    </div>
  </div>
</ng-template>